import { render } from "./CustomerForm.vue?vue&type=template&id=4b4f8d21&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"

import "./CustomerForm.vue?vue&type=style&index=0&id=4b4f8d21&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4f8d21"]])

export default __exports__